import { ErrorResponse} from '@gtpl/shared-models/common-models';
import { AllvalueAdditionThreeResponse, ValueAdditionIdModel, valueAdditionIdResponse, ValueAdditionThreeDto, valueAdditionThreeResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogActions } from 'apps/services/logger/logger-functions';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Repository } from 'typeorm';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { ValueAddThreeTypeAdapter } from './dto/value-addition-three.adapter';
import { ValueAdditionThreeDTO } from './dto/value-addition-three.dto';
import { ValueAdditionThreeRequest } from './dto/value-addition-three.request';
import { ValueAdditionThreeType } from './value-addition-three.entity';

@Injectable()
export class ValueAddition3TypesService {
    constructor(
      private logService:LogsService,

        @InjectRepository(ValueAdditionThreeType) private foodTypeRepository: Repository<ValueAdditionThreeType>,
        private valAddThreeAdapter: ValueAddThreeTypeAdapter,
      ) { }

    //create method
      async createValAddThreeType(valAddDto:ValueAdditionThreeDTO,isUpdate:boolean=false,@Req() request:Request): Promise<valueAdditionThreeResponse> {
        try {
        let previousValue;
        if (!isUpdate) {
            const valAddThreeTypeEntity = await this.getValAddThreeType(valAddDto.code);
          if (valAddThreeTypeEntity) {
            throw new valueAdditionThreeResponse(false,11104, 'Value Addition Type already exists');
          }
        }
        else {
            const certificatePrevious = await this.foodTypeRepository.findOne({where:{valueAdditionThreeId:valAddDto.valueAdditionThreeId}})
            previousValue = certificatePrevious.name+" ,"+certificatePrevious.code
            const valAddThreeTypeEntity = await this.getValAddThreeType(valAddDto.code);
          if (valAddThreeTypeEntity) {
              if(valAddThreeTypeEntity.valueAdditionThreeId!=valAddDto.valueAdditionThreeId){
                throw new valueAdditionThreeResponse(false,11104, 'Value Addition Type already exists');
              }
          }
        }
        const convertedvalAddTypeEntity: ValueAdditionThreeType = this.valAddThreeAdapter.convertDtoToEntity(valAddDto,isUpdate);
        const savedValAddEntity: ValueAdditionThreeType = await this.foodTypeRepository.save(convertedvalAddTypeEntity);
        const savedValAddTypeDto: ValueAdditionThreeDTO = this.valAddThreeAdapter.convertEntityToDto(savedValAddEntity);
       
         if (savedValAddTypeDto) {
            const present = savedValAddEntity.name+' ,'+savedValAddEntity.code
          const response = new valueAdditionThreeResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Value Addition Three Type Updated Successfully':'Value Addition Type Created Successfully',savedValAddTypeDto);
          const name=isUpdate?'updated':'created'
          const displayValue = isUpdate? 'Value Addition Three Type Updated Successfully': 'Value Addition Three Type Created Successfully'
            const userName = isUpdate? savedValAddTypeDto.updatedUser :savedValAddTypeDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'ValueAdditionThreeDTO', savedValAddTypeDto.valueAdditionThreeId, true, displayValue,userName,previousValue,present)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
          return response;
        } else {
          throw new valueAdditionThreeResponse(false,11106,'Value Addition Three Type saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    /**
     * gets all  val addition one types details  
     * @returns all the val addition one type details .
     */
    // @LogActions({ isAsync: true })
        async getAllValAddThreeTypes(req?:UserRequestDto): Promise<AllvalueAdditionThreeResponse> {  
            try {
                const valAddDto: ValueAdditionThreeDto[] = [];
                // retrieves all plants
                const valAddOneTypeEntities: ValueAdditionThreeType[] = await this.foodTypeRepository.find({
                    order: { name: "ASC" },
                });
                //   console.log(valAddOneTypeEntities);
                if (valAddOneTypeEntities.length>0) {
                    valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                    const convertedValAddTypeDto: ValueAdditionThreeDto = this.valAddThreeAdapter.convertEntityToDto(valAddOneTypeEntity);
                    valAddDto.push(convertedValAddTypeDto);
                    });
                    const response = new AllvalueAdditionThreeResponse(true, 11208, "Value Addition Types retrieved successfully", valAddDto);
                    if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'ValueAdditionThreeDTO', 0, true, 'Value Addition Types retrieved successfully',req.createdUser,'','')
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                    }
                    return response;
                } else {
                    //   console.log('yest')
                    throw new valueAdditionThreeResponse(false,99998, 'No Records Found');
                }
        } catch (err) {
        throw err;
        }
    }

     /**
     * gets all  active val addition three types details  
     * @returns all the val addition one type details .
     */
    // @LogActions({ isAsync: true })
    async getAllAvtiveValAddThreeTypes(): Promise<AllvalueAdditionThreeResponse> {  
        try {
            const valAddDto: ValueAdditionThreeDto[] = [];
            // retrieves all plants
            const valAddOneTypeEntities: ValueAdditionThreeType[] = await this.foodTypeRepository.find({
                where:{isActive:true},order: { name: "ASC" },
            });
            //   console.log(valAddOneTypeEntities);
            if (valAddOneTypeEntities.length>0) {
                valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                const convertedValAddTypeDto: ValueAdditionThreeDto = this.valAddThreeAdapter.convertEntityToDto(valAddOneTypeEntity);
                valAddDto.push(convertedValAddTypeDto);
                });
                const response = new AllvalueAdditionThreeResponse(true, 11208, "Value Addition Types retrieved successfully", valAddDto);
                return response;
            } else {
                //   console.log('yest')
                throw new valueAdditionThreeResponse(false,99998, 'No Records Found');
            }
    } catch (err) {
    throw err;
    }
}

    /**
     * It deactivates value addition value  type 
     * @param foodTypeRequest addition  type  as string
     * @returns true or false
     */
    //  @LogActions({isAsync: true})
     async activateOrDeactivateValAddThreeType(valAddOneReq: ValueAdditionThreeRequest): Promise<valueAdditionThreeResponse> {
         try {
             const FoodTypeExists = await this.getValAddTypeById(valAddOneReq.valueAdditionThreeId);
             if (FoodTypeExists) {
                 if (valAddOneReq.versionFlag !== FoodTypeExists.versionFlag) {
                     throw new valueAdditionThreeResponse(false,10113, 'Someone updated the current value addition information.Refresh and try again');
                 } else {
                     
                         const foodTypeSatatus =  await this.foodTypeRepository.update(
                             { valueAdditionThreeId: valAddOneReq.valueAdditionThreeId },
                             { isActive: valAddOneReq.isActive,updatedUser: valAddOneReq.updatedUser });
                        
                         if (FoodTypeExists.isActive) {
                             if (foodTypeSatatus.affected) {
                                 const foodTypeResponse: valueAdditionThreeResponse = new valueAdditionThreeResponse(true, 10115, 'Value Addition Type is de-activated successfully');
                                 return foodTypeResponse;
                             } else {
                                 throw new valueAdditionThreeResponse(false,10111, 'Value addition Type is already deactivated');
                             }
                         } else {
                             if (foodTypeSatatus.affected) {
                                 const foodTypeResponse: valueAdditionThreeResponse = new valueAdditionThreeResponse(true, 10114, 'Value addition type is activated successfully');
                                 return foodTypeResponse;
                             } else {
                                 throw new valueAdditionThreeResponse(false,10112, 'Value addition type is already  activated');
                             }
                         }
                     // }
                 }
             } else {
                 throw new valueAdditionThreeResponse(false,99998, 'No Records Found');
             }
         } catch (err) {
             throw err;
         }
     }

    async getValAddThreeType(valAddThreeCode: string): Promise<ValueAdditionThreeType> {
    //  console.log(employeeId);
        const response = await this.foodTypeRepository.findOne({
        where: {code: valAddThreeCode},
        });
        // console.log(response);
        if (response) {
        return response;
        } else {
        return null;
        }
    }

    async getValAddTypeById(valueAdditionId: number): Promise<ValueAdditionThreeType> {
        //  console.log(employeeId);
            const Response = await this.foodTypeRepository.findOne({
            where: {valueAdditionThreeId: valueAdditionId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }

    /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     */
    async getValAddDetails(valueAdditionId: number): Promise<valueAdditionIdResponse> {
        const valAddData = await this.foodTypeRepository.findOne({select: ['name','code'], where: {valueAdditionThreeId: valueAdditionId}});
        if(valAddData) {
            const modelResponse = new ValueAdditionIdModel(valAddData.name, valAddData.code);
            const response = new valueAdditionIdResponse(true, 11208, "Value Addition Types retrieved successfully", modelResponse);
            return response;
        } else {
            return null;
        }   
    }    
}
